<div class="row" id="main-content">
  <div class="col-sm-12 h-100">
    <div class="row">
      <div class="col-sm-12 menu">
        <mat-form-field appearance="fill" style="width: 20%">
          <mat-label>Date range</mat-label>
          <mat-date-range-input [rangePicker]="picker" [max]="maxDate">
            <input matStartDate #startDate placeholder="Start date" [value]="selectedStartDate">
            <input matEndDate #endDate placeholder="End date" [value]="selectedEndDate" (dateChange)="selectedEndDateChange(startDate, endDate)">
          </mat-date-range-input>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        @if (depots != null && depots.length > 1) {
          <mat-form-field appearance="fill" style="width: 15%">
            <mat-label>Depot</mat-label>
            <mat-select [(value)]="selectedDepotId" (selectionChange)="depotChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
              @for (depot of depots; track depot) {
                <mat-option [value]="depot.id">{{depot.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        <mat-form-field appearance="fill" style="width: 22%">
          <mat-label>Tip Location</mat-label>
          <mat-select [(value)]="selectedTipLocationId" (selectionChange)="tipLocationChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (location of tipLocations; track location) {
              <mat-option [value]="location.id">{{location.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 22%">
          <mat-label>HWRC Location</mat-label>
          <mat-select [(value)]="selectedWasteLocationId" (selectionChange)="wasteLocationChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (location of wasteLocations; track location) {
              <mat-option [value]="location.id">{{location.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 15%">
          <mat-label>Vehicle</mat-label>
          <mat-select [(value)]="selectedVehicleId" (selectionChange)="vehicleChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (vehicle of customerVehicles; track vehicle) {
              <mat-option [value]="vehicle.id">{{vehicle.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 18%">
          <mat-label>Waste</mat-label>
          <mat-select [(value)]="selectedWasteId" (selectionChange)="wasteChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (waste of customerWastes; track waste) {
              <mat-option [value]="waste.id">{{waste.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-sm-12 services">
        <table class='table table-striped' aria-labelledby="tableLabel">
          <thead>
            <tr>
              <th class="vehicle">Vehicle</th>
              <th class="location">Tip Location</th>
              <th class="location">HWRC Location</th>
              <th class="arrived">Arr</th>
              <th class="departed">Dep</th>
              <th class="time">Time at Site</th>
              <th class="variance">VA</th>
              <th class="variance">Waste</th>
              <th class="exp">
                <button (click)="exportToCSV()" title="Export Data" class="export-button" >
                  <img class="export-image" alt="Export Data" src="../../img/btnExport.png" />
                </button>
              </th>
            </tr>
          </thead>
          <tbody class="dummy">
            <tr>
              <td class="h-2" colspan="9"></td>
            </tr>
          </tbody>
          <tbody>
            @for (service of servicesPage; track service) {
              <tr [className]="service.alert ? 'warning' : ''" (click)="goToLocation(service.locationId)">
                <td class="vehicle"><div>{{ service.vehicleName }}</div></td>
                <td class="location"><div>{{ service.locationName }}</div></td>
                <td class="location"><div>{{ service.sourceLocation }}</div></td>
                <td class="arrived" title="{{ service.arrivedAt | date:'mediumDate' }}"><div>{{ service.arrivedAtFormatted }}</div></td>
                <td class="departed"title="{{ service.departedAt | date:'mediumDate' }}"><div>{{ service.departedAtFormatted }}</div></td>
                <td class="time"><div>{{ service.timeAtSiteFormatted }}</div></td>
                <td class="variance"><div [className]="service.variance == 0 ? '' : service.variance > 0 ? 'warning' : 'good'">{{ service.variance }}</div></td>
                <td class="in"><div>{{ service.wasteType }}</div></td>
                <td class="exp"></td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
